const errorSubtle = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0m-7 8A8 8 0 1 0 8 0a8 8 0 0 0 0 16M5.03 3.97l7 7-1.06 1.06-7-7z" clip-rule="evenodd"/></svg>',
};

export { errorSubtle as default };
